import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_BG.json';
import audios from './LOVE_AUDIOS_BG.json';

export const LOVE_DATA_BG: ServiceData = {
  articles,
  audios,
};
